export const HIDE_SERVICE_INTERNAL_ID = 'hide_service';
export const HIDE_RETURN_INTERNAL_ID = 'hide_return';
export const DISABLE_COMPARISONS_INTERNAL_ID = 'disable_product_comparisons';
export const SHOW_CATCH_PUSH_PROMO_INTERNAL_ID = 'showCatchPushPromo';
export const ENABLE_STICKY_PRODUCT_INFO_INTERNAL_ID = 'enable_sticky_product_info';

export const experimentsConfig = [
  {
    name: HIDE_SERVICE_INTERNAL_ID,
    groups: [{ name: 'A', weight: 1 }],
    trafficPercentRange: 1,
  },
  {
    name: HIDE_RETURN_INTERNAL_ID,
    groups: [{ name: 'A', weight: 1 }],
    trafficPercentRange: 1,
  },
];
